<div class="uses-section" *ngIf="zoningCode">
    <div class="section-header">
        <ziq-uses-visible-fields *ngIf="!hideUseComponentsSelection"
            [visibilityOptions]="usesVisibleFields"></ziq-uses-visible-fields>
        <div *ngIf="hideUseComponentsSelection"></div>
        <mat-paginator [length]="table?.value?.length" [pageSize]="pageSize" [hidePageSize]="true"
            (page)="pageEvent = $event; setPageData($event)"></mat-paginator>
    </div>

    <div class="uses-table">
        <div class="header">
            <div class="uses-fields-header"></div>
            <div class="column-body">
                <div class="row" *ngFor="let column of columnsToShow">
                    <div class="actions-row">
                        <cut-down-content length="13"
                            [ngClass]="{'red-text': column?.calibrationSet?.importValidationResult && !column?.calibrationSet?.importValidationResult.isValid}">{{column.calibrationSet.Name}}</cut-down-content>
                        <div class="actions-container">
                            <ziq-clone-uses-button *ngIf="!hideAttributeButtons"
                                [calibrationSet]="column.calibrationSet"
                                [calibrationSetType]="this.calibrationSetType"></ziq-clone-uses-button>
                            <calibration-set-attributes *ngIf="!hideAttributeButtons"
                                [identifiers]="column.calibrationSet.identifier"
                                [attributePopupTitleDetails]="column.calibrationSet.Name">
                            </calibration-set-attributes>
                        </div>
                    </div>
                    <div class="icons-container to-right">
                        <ziq-calibration-set-attributes-icons *ngIf="!hideAttributeButtons"
                            [attributesFlags]="column.calibrationSet">
                        </ziq-calibration-set-attributes-icons>
                    </div>
                </div>
            </div>
        </div>
        <accordion [allowMultipleOpenedSections]="true">
            <accordion-group *ngFor="let useType of usesTypes; index as i" [title]="useType.Name ? useType.Name : 'Empty Calibration Use Type Label'"
                [active]="!!(i===0)" [templateRef]="useTypeTable"
                [titleClass]="useType?.importValidationResult && !useType?.importValidationResult.isValid ? 'red-text' : ''">
                <ng-template #useTypeTable>
                    <use-type-table [useType]="useType" [columns]="columnsToShow"
                        [visibilityOptions]="usesVisibleFields" [useAllowances]="allowancesList"
                        [currentTab]="currentTab" [hideAttributeButtons]="hideAttributeButtons" [readOnly]="readOnly">
                    </use-type-table>
                </ng-template>
            </accordion-group>
        </accordion>
    </div>
</div>
